var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('main',{staticClass:"wrapper"},[_c('section',{staticClass:"loaders loaders-bg-2"},[_c('span',{staticClass:"loader loader-double"}),_c('span',{staticClass:"loader-txt"},[_vm._v("Loading...")])])])
}]

export { render, staticRenderFns }